// Global swatch color management
window.SwatchColorManager = window.SwatchColorManager || {
  colorMappings: {
    'white': '#ffffff',
    'black': '#000000', 
    'red': '#dc2626',
    'blue': '#2563eb',
    'yellow': '#eab308',
    'green': '#16a34a',
    'pink': '#ec4899',
    'navy': '#1e40af',
    'purple': '#9333ea',
    'orange': '#f97316',
    'charcoal': '#374151',
    'grey': '#6b7280',
    'gray': '#6b7280'
  },
  
  applySwatchColor: function(swatchElement) {
    // Skip if this swatch already has proper styling from the theme
    if (swatchElement.style.getPropertyValue('--swatch-background') || 
        swatchElement.getAttribute('style')?.includes('--swatch-background')) {
      return;
    }
    
    // Skip if this swatch is using a custom image
    if (swatchElement.classList.contains('swatch--has-custom-image')) {
      return;
    }
    
    const variantValue = swatchElement.getAttribute('data-variant-value');
    const fallbackColor = swatchElement.getAttribute('data-fallback-color');
    
    if (!variantValue && !fallbackColor) return;
    
    let colorToApply = fallbackColor;
    
    // If we have variant value, try to match it
    if (variantValue) {
      const variantLower = variantValue.toLowerCase();
      
      // Check if variant matches any color
      for (const [colorName, colorValue] of Object.entries(this.colorMappings)) {
        if (variantLower.includes(colorName)) {
          colorToApply = colorValue;
          break;
        }
      }
    }
    
    // Apply the color only as a fallback
    if (colorToApply) {
      swatchElement.style.setProperty('--swatch-background', colorToApply);
      swatchElement.style.background = colorToApply;
      swatchElement.classList.add('swatch--theme-color');
      
      // Add border for white swatches
      if (colorToApply === '#ffffff' || colorToApply === '#FFFFFF') {
        swatchElement.style.border = '1px solid #e5e7eb';
      }
    }
  },
  
  applyAllColors: function() {
    const swatches = document.querySelectorAll('.swatch[data-variant-value], .swatch[data-fallback-color]');
    swatches.forEach(this.applySwatchColor.bind(this));
  },
  
  init: function() {
    // Apply colors immediately and set up multiple triggers for initial load
    this.applyAllColors();
    
    // Set up multiple timing approaches for initial page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.applyAllColors.bind(this));
    }
    
    // Additional timing fallbacks for initial load
    setTimeout(this.applyAllColors.bind(this), 100);
    setTimeout(this.applyAllColors.bind(this), 300);
    setTimeout(this.applyAllColors.bind(this), 500);
    
    // Watch for page load completion
    window.addEventListener('load', this.applyAllColors.bind(this));
    
    // Hook into variant picker changes with more specific targeting
    document.addEventListener('click', function(e) {
      const button = e.target.closest('input[type="radio"][name*="Mug Inside & Handle Colour"], .variant-option__button-label');
      if (button) {
        // Multiple timeouts to catch different DOM update timings
        setTimeout(function() {
          window.SwatchColorManager.applyAllColors();
        }, 50);
        
        setTimeout(function() {
          window.SwatchColorManager.applyAllColors();
        }, 150);
        
        setTimeout(function() {
          window.SwatchColorManager.applyAllColors();
        }, 300);
      }
    });
    
    // Use MutationObserver for DOM changes
    const observer = new MutationObserver(function(mutations) {
      let needsUpdate = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.classList && node.classList.contains('swatch')) {
                needsUpdate = true;
              } else if (node.querySelector && node.querySelector('.swatch')) {
                needsUpdate = true;
              }
            }
          });
        } else if (mutation.type === 'attributes' && mutation.target.classList && mutation.target.classList.contains('swatch')) {
          needsUpdate = true;
        }
      });
      
      if (needsUpdate) {
        setTimeout(function() {
          window.SwatchColorManager.applyAllColors();
        }, 10);
        setTimeout(function() {
          window.SwatchColorManager.applyAllColors();
        }, 50);
        setTimeout(function() {
          window.SwatchColorManager.applyAllColors();
        }, 150);
      }
    });
    
    // Start observing
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
      });
    }
  }
};

// Auto-initialize when script loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    window.SwatchColorManager.init();
  });
} else {
  window.SwatchColorManager.init();
}